// @flow

import { StyleSheet } from 'react-native';
import { GRAY_COLOR, PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';

const backgroundColor = '#ffffff';

const _styles = {
    accountWrapper: {
        paddingHorizontal: 30,
        marginBottom: 30,
        justifyContent: 'center',
        alignItems: 'center',
    },
    accountWrapperMobile: {
        paddingHorizontal: 0,
    },
    accountContainer: {
        backgroundColor,
        borderRadius: 28,
        borderWidth: 3,
        borderColor: backgroundColor,
        marginBottom: 20,
        height: 120,
        width: 300,
        justifyContent: 'center',
        alignItems: 'center',
    },
    accountActive: {
        borderColor: PRIMARY_COLOR,
    },
    trialLogo: {
        width: '70%',
        height: '80%',
    },
    addressText: {
        fontSize: 16,
        color: GRAY_COLOR,
        textAlign: 'center',
    },
    accountsListWrapper: {
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    accountsListWrapperMobile: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
};

const styles: typeof _styles = StyleSheet.create(_styles);

export default styles;
